
<template>
  <div class="task-container">
    <!-- 列表头部栏 -->
    <r-pointer :textName="`${$t('task.taskManagement')}`">
    </r-pointer>
    <!-- 搜索模块 -->
    <r-search
      class="p_search"
      @on-blur="getCommonSearchOpt"
      @on-search="handleCommonSearch">
      <div slot="senior">
        <a-form :form="form" @submit="handleSearch" layout="inline" >
          <a-row :gutter="12">
            <a-col :span="8">
              <a-form-item :label="`${$t('formAbout.procName')}`" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'procCode',
                    { initialValue: '' }]">
                  <a-select-option value="">-- {{ $t('formAbout.all') }} --</a-select-option>
                  <a-select-option v-for="(item, index) in proList" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="`${$t('formAbout.robot')}`" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'currRobotNo',
                    { initialValue: '' }]">
                  <a-select-option value="">-- {{ $t('formAbout.all') }} --</a-select-option>
                  <a-select-option v-for="(item, index) in robotList" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="`${$t('formAbout.taskStatus')}`" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'status',
                    { initialValue: '' }]">
                  <a-select-option value="">-- {{ $t('formAbout.all') }} --</a-select-option>
                  <a-select-option v-for="(item, index) in taskStatusList" :key="index" :value="item.value" v-if="item.value != 'pendout'"> {{ item.label }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="16">
              <a-form-item :label="`${$t('formAbout.taskTime')}`" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <a-range-picker
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  v-decorator="[
                    'taskTime']"
                  @change="selectRangeDate"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="8" class="btn_gruop">
              <a-col span="6"></a-col>
              <a-col span="18">
                <a-button type="primary" html-type="submit" > {{ $t('formAbout.searchBtn') }} </a-button>
                <a-button :style="{ marginLeft: '8px' }" @click="handleReset"> {{ $t('formAbout.clear') }} </a-button>
              </a-col>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </r-search>
    <!-- 表格列表 -->
    <a-table
      :columns="columns"
      :dataSource="dataList"
      :rowSelection="rowSelection"
      :pagination="pagination"
      :loading="loading"
      rowKey="id">
      <!-- 流程名 -->
      <span slot="name" slot-scope="record">
        <template>
          <div>{{ record.procName || $t('operation.notAvailable') }}</div>
          <div class="td-nowrap">{{ $t('task.publish') }}：{{ record.publishTime || $t('operation.notAvailable') }}</div>
          <div>{{ $t('task.version') }}：{{ record.procVer || $t('operation.notAvailable') }}</div>
        </template>
      </span>
      <!-- 状态 -->
      <span class="td-nowrap" slot="status" slot-scope="text">
        <template>
          <i :class="`iconfont icon${text.status} ${text.status}`"></i>
          {{ taskStatus[text.status] }}
        </template>
      </span>
      <!-- 机器人范围 -->
      <span slot="range" slot-scope="record">
        <template>
          <!-- <div>{{ record.agentAlias ? record.agentAlias : !record.userName&&!record.userDomain ? $t('operation.notAvailable') : `${record.userName || ''}@${record.userDomain || ''}` }}</div> -->
          <div>{{ record.agentAlias ? record.agentAlias : !record.userName&&!record.agentName ? $t('operation.notAvailable') : `${record.userName || ''}@${record.agentName || ''}` }}</div>
          <div>{{ record.agentIp ? record.agentIp.split(',').join('，') : $t('operation.notAvailable') }}</div>
          <div class="robot-w">{{ record.agentDcode || $t('operation.notAvailable') }}</div>
        </template>
      </span>
      <!-- 任务详情 -->
      <span slot="taskInfo" slot-scope="record">
        <template>
          <div class="td-nowrap">{{ $t('task.start') }}：{{ formatTime(record.startTime) || $t('operation.notAvailable') }}</div>
          <div class="td-nowrap">{{ $t('task.end') }}：{{ formatTime(record.endTime) || $t('operation.notAvailable') }}</div>
          <div>ID：{{ record.jobNo || $t('operation.notAvailable') }}</div>
        </template>
      </span>
      <!-- 操作 -->
      <div slot="operation" slot-scope="record">
        <!-- 播放 -->
        <a @click="play(record.id)">{{ $t('page.task.action[0]') }}</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <!-- 更多 -->
          <a class="ant-dropdown-link"> {{ $t('page.task.action[8]') }} <a-icon type="down" /> </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <!-- 业务日志 -->
              <a @click="handleLog(record.jobNo)">{{ $t('page.task.action[6]') }}</a>
            </a-menu-item>
            <a-menu-item v-if="record.status === 'running'">
              <!-- 停止 -->
              <a @click="handleStop(record.id)">{{ $t('page.task.action[3]') }}</a>
            </a-menu-item>
            <a-menu-item v-if="record.status === 'failed'">
              <!-- 重做 -->
              <a @click="handleReAction(record)">{{ $t('page.task.action[1]') }}</a>
            </a-menu-item>
            <a-menu-item v-if="record.status !== 'running' && record.status !== 'stopping'">
              <!-- 删除 -->
              <a @click="handleDel(record.id)">{{ $t('page.task.action[5]') }}</a>
            </a-menu-item>
            <a-menu-item v-if="downloadableStatus.indexOf(record.status) !== -1">
              <!-- 运行日志下载 -->
              <a @click="handleRunLogDownload(record)">{{ $t('page.task.action[7]') }}</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </a-table>

    <!-- 批量操作 -->
    <a-row class="multi-select" v-if="pagination.total>0">
      <a-col>
        <!-- 启动 -->
        <!-- <a-button :disabled="selectedRowNum!=1">{{ $t('page.task.action[2]') }}</a-button> -->
        <!-- 停止 -->
        <a-button :disabled="selectedRowNum<1" @click="handleStop(selectedRowData, true)">{{ $t('page.task.action[3]') }}</a-button>
        <!-- 重启 -->
        <!-- <a-button :disabled="selectedRowNum!=1">{{ $t('page.task.action[4]') }}</a-button> -->
        <!-- 删除 -->
        <a-button :disabled="selectedRowNum<1" @click="handleDel(selectedRowData, true)">{{ $t('page.task.action[5]') }}</a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { apiTask } from '@/api/taskM'
import { apiRobot } from '@/api/robot'
import { apiProcess } from '@/api/process'
import { getVideoInfo } from '@api/play'

import { parseTime } from '@/utils/util'
import { tipMsg, modalTip } from '@/utils/tipTools'
import moment from 'moment'

export default {
  data () {
    // 表格列信息
    const columns = [
      {
        title: this.$t('task.procName'),
        align: 'left',
        width: 230,
        key: 'name',
        scopedSlots: { customRender: 'name' }
      },
      {
        title: this.$t('task.taskStatus'),
        align: 'left',
        width: 120,
        /* filters: [
          { value: 'pending', text: '等待派发' },
          { value: 'running', text: '正在执行' },
          { value: 'success', text: '执行成功' },
          { value: 'failing', text: '失败中的' },
          { value: 'failed', text: '已经失败' },
          { value: 'stopping', text: '准备停止' },
          { value: 'stopped', text: '已停止' }
        ], */
        key: 'status',
        scopedSlots: { customRender: 'status' }
      },
      {
        title: this.$t('task.robotRange'),
        align: 'left',
        key: 'range',
        // width: 220,
        scopedSlots: { customRender: 'range' }
      },
      {
        title: this.$t('task.taskDetail'),
        align: 'left',
        key: 'taskInfo',
        width: 220,
        scopedSlots: { customRender: 'taskInfo' }
      },
      {
        title: this.$t('operation.tableOperation'),
        key: 'operation',
        align: 'left',
        width: 150,
        scopedSlots: { customRender: 'operation' }
      }
    ]
    return {
      form: this.$form.createForm(this),
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      // 机器人列表
      robotList: [],
      // 流程列表
      proList: [],
      columns,
      // 任务列表查询入参
      params: {
        fuzzyQuery: '', // 模糊查询参数
        procCode: '', // 流程名
        agentAlias: '', // 机器人别名
        currRobotNo: '', // 机器人编号
        status: '', // 状态：pending:等待派发 running:正在执行 success:执行成功 failing:失败中的 failed:已经失败 stopping:准备停止 stopped:已停止
        startTime: '', // 任务开始时间
        endTime: '' // 任务结束时间
      },
      // 任务状态，键值对
      taskStatus: {
        pending: this.$t('task.status.pending'),
        pendout: this.$t('task.status.pendout'),
        running: this.$t('task.status.running'),
        succ: this.$t('task.status.success'),
        timeout: this.$t('task.status.timeout'),
        failing: this.$t('task.status.failing'),
        failed: this.$t('task.status.failed'),
        stopping: this.$t('task.status.stopping'),
        stopped: this.$t('task.status.stopped')
      },
      // 可下载运行日志的状态
      downloadableStatus: ['succ', 'failed', 'stopped'],
      // 列表数据
      dataList: [],
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        size: 'samll',
        showSizeChanger: true, // 可以改变 pageSize
        showTotal: total => `${this.$t('operation.total')} ${total} ${this.$t('operation.items')}，`,
        showQuickJumper: true, // 可以快速跳转至某页
        onChange: this.handlePagition,
        onShowSizeChange: this.handlePageSize
      },
      loading: false,
      // 表格选择功能
      selectedRowKeys: [], // 用来控制选择
      // 批量选择的数据
      selectedRowData: '',
      // 选择数据的状态
      selectedRowDataStatus: [],
      // 批量选择的row数据
      selectedRowsData: '',
      // 选中数据的条数，用来控制表格下方多选操作按钮的可操作性
      selectedRowNum: 0
    }
  },
  computed: {
    // 任务状态
    taskStatusList () {
      const statusArr = []
      Object.keys(this.taskStatus).forEach(key => {
        statusArr.push({
          label: this.taskStatus[key],
          value: key
        })
      })
      return statusArr
    },
    // 表格选择
    rowSelection () {
      return {
        onChange: this.onSelectChange,
        selectedRowKeys: this.selectedRowKeys
        // onSelect: (record, selected, selectedRows) => {
        //   console.log(record, selected, selectedRows)
        // },
        // onSelectAll: (selected, selectedRows, changeRows) => {
        //   console.log(selected, selectedRows, changeRows)
        // }
      }
    }
  },
  watch: {
    $route (val) {
      // console.log(val)
      this._fetchList()
    }
  },
  created () {
    // 机器人编号
    this.params.currRobotNo = this.$route.query.robot_name || ''
    // 机器人别名
    // this.params.agentAlias = this.$route.query.robot_name || ''
    // 流程名
    this.params.procCode = this.$route.query.pro_code || ''
    // 获取任务列表
    this._fetchList()
    // 获取机器人列表数据
    this._fetchRobotList()
    // 获取流程名列表数据
    this._fetchProList()
  },
  methods: {
    moment,
    play (id) {
      getVideoInfo(id).then((res) => {
        if (res) {
          this.$router.push('/task/' + id)
        } else {
          this.$message.info(this.$t('page.play.tips[0]'))
        }
      })
    },
    /**
     * 失焦获取普通搜索条件值
     */
    getCommonSearchOpt (opt) {
      // alert(opt)
      this.params.fuzzyQuery = opt
    },
    /**
     * 模糊搜索
     */
    handleCommonSearch () {
      // alert('模糊搜索')
      this.pagination.current = 1
      this._fetchList()
    },
    /**
     * 获取机器人列表数据
     */
    _fetchRobotList () {
      apiRobot.list().then(data => {
        this.robotList = []
        data.items.forEach(item => {
          this.robotList.push({
            // value: `${item.id}_${item.agentAlias || item.agentNo}`,
            value: item.agentNo,
            label: item.agentAlias || item.agentNo
          })
        })
      })
    },
    /**
     * 获取流程列表数据
     */
    _fetchProList () {
      apiProcess.list().then(data => {
        this.proList = []
        data.items.forEach(item => {
          this.proList.push({
            // value: `${item.id}_${item.procName || item.procCode}`,
            value: item.procCode,
            label: item.procName || item.procCode
          })
        })
      })
    },
    /**
     * 时间转换
     */
    formatTime (time, format) {
      if (time) {
        return parseTime(time)
      }
    },
    /**
     * 任务时间
     */
    selectRangeDate (date, dateArr) {
      Object.assign(this.params, {
        startTime: dateArr[0],
        endTime: dateArr[1]
      })
    },
    // 表格分页
    handlePagition (page, pageSize) {
      this.pagination.current = page
      this._fetchList()
    },
    // 表格切换size
    handlePageSize (current, pageSize) {
      this.pagination.pageSize = pageSize
      this._fetchList()
    },
    // 表格选中操作
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      // 选中数据的id
      this.selectedRowData = selectedRowKeys.join(',')
      // 选中row数据
      this.selectedRowsData = selectedRows
      this.selectedRowNum = selectedRowKeys.length
      // 拿到每个选中数据的状态
      selectedRows.forEach(item => {
        this.selectedRowDataStatus.push(item.status)
      })
    },
    /**
     * 获取任务列表数据
     */
    _fetchList () {
      // 查看路由是否带有机器人参数
      // console.log(this.$route.query.robot_name)
      // 清空选中记录
      this.selectedRowKeys = []
      this.selectedRowNum = 0
      this.loading = true
      // 获取任务列表数据
      apiTask.list(this.params, this.pagination.current, this.pagination.pageSize).then(data => {
        // console.log(data)
        this.pagination.total = data.total
        this.dataList = data.items
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    handleSearch (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values)
          // 遍历form获取到的字段，赋值给params
          Object.keys(values).forEach(key => {
            if (key === 'taskTime') {
              // console.log(values[key])
              if (values[key] && values[key].length > 0) {
                this.params.startTime = values[key][0].format('YYYY-MM-DD HH:mm:ss')
                this.params.endTime = values[key][1].format('YYYY-MM-DD HH:mm:ss')
              }
            } else {
              this.$set(this.params, key, values[key])
              // this.params[key] = values[key]
            }
            /**
             *  else if (key === 'procCode' || key === 'currRobotNo') {
              this.params[key] = values[key] ? values[key].split('_')[1] : ''
            }
             */
          })
          // console.log(this.params)
          this.pagination.current = 1
          this._fetchList()
        }
      })
    },
    /**
     * 高级搜索表单清空
     */
    handleReset () {
      this.form.resetFields()
      this.params.startTime = ''
      this.params.endTime = ''
    },
    // 任务日志详情
    handleDetail (row) {
      console.log(row)
    },
    // 任务日志
    handleLog (jobNo) {
      // console.log(jobNo)
      this.$router.push(`/log?jobNo=${jobNo}`)
    },
    // 停止
    handleStop (rowID, isBulk = false) {
      // console.log(row)
      // 仅 running 状态才可以停止
      // 筛选用户选择的数据，仅提供 running 状态相关的
      if (isBulk) {
        // if (this.selectedRowDataStatus.length >= 1 && this.selectedRowDataStatus.indexOf('running') === -1) {
        //   tipMsg('warning', `${this.$t('task.stopCheckTipMsg')}`)
        //   return
        // }
        rowID = []
        this.selectedRowsData.forEach(row => {
          if (row.status === 'running') {
            rowID.push(row.id)
          }
        })
        rowID = rowID.join(',')
      }
      modalTip(
        'confirm',
        `${this.$t('task.stopTipMsg')}`,
        () => {
          apiTask.stop({
            id: rowID
          }).then(data => {
            tipMsg('success', `${this.$t('task.stopping')}`)
            // 重新获取数据列表
            this._fetchList()
          })
        }
      )
    },
    // 删除
    handleDel (rowID, isBulk = false) {
      // console.log(row)
      this.realDel(rowID, isBulk)
    },
    // 删除，可批量删除
    realDel (delItem, isBulk) {
      // 非 running 、stopping 状态才可以删除
      // 筛选用户选择的数据，仅提供 running 状态相关的
      if (isBulk) {
        // if (this.selectedRowDataStatus.indexOf('running') !== -1 || this.selectedRowDataStatus.indexOf('stopping') !== -1) {
        //   tipMsg('warning', `${this.$t('task.delCheckTipMsg')}`)
        //   return
        // }
        delItem = []
        this.selectedRowsData.forEach(row => {
          if (row.status !== 'running' && row.status !== 'stopping') {
            delItem.push(row.id)
          }
        })
        delItem = delItem.join(',')
      }
      modalTip(
        'confirm',
        `${this.$t('task.delTipMsg')}`,
        () => {
          apiTask.del({
            ids: delItem
          }).then(data => {
            tipMsg('success', `${this.$t('msg.delSuceess')}`)
            // 清空之前选中的数据
            this.cleanSelectd()
            // 重新获取数据列表
            this._fetchList()
          })
        }
      )
    },
    // 清空之前选中的数据
    cleanSelectd () {
      // console.log(this.selectedRowData)
      this.selectedRowData = ''
      this.selectedRowNum = 0
    },
    // 重做
    handleReAction (row) {
      // console.log(row)
      apiTask.reStart({
        result: row.status,
        job_id: row.id
      }).then(data => {
        tipMsg('success', `${this.$t('task.readyToReDo')}`)
        // 重新获取数据列表
        this._fetchList()
      })
    },
    // 运行日志下载
    handleRunLogDownload (row) {
      // console.log(row)
      apiTask.logFile(row.jobNo).then(fileRes => {
        // console.log(fileRes)
        if (fileRes === 'No logs to download') {
          tipMsg('warning', this.$t('task.logDownloadMsg'))
        } else {
          window.open(apiTask.openLogFile(row.jobNo))
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .task-container {
    background-color: #fff;
    padding: 0 24px 12px;
    position: relative;
  }
  // 日期时间选择器
  /deep/.ant-calendar-picker {
    width: 100%!important;
  }
  // 机器人 列宽
  .robot-w {
    word-break: break-all;
  }
  .td-nowrap {
    white-space: nowrap;
  }
  // 表格底部，多选操作涉及的按钮
  .multi-select {
    position: absolute;
    bottom: 32px;
    width: 150px!important;
    button {
      margin-right: 5px;
    }
  }
  // 高级搜索的按钮
  .btn_gruop {
    margin: 10px -5px;
  }
  // 表单
  .ant-row {
    margin-top: 5px;
    width: 100%;
    /deep/.ant-form-item-label {
      text-align: left;
      // width: 100px;
    }
  }
  // 任务日志详情
  .log-detail {
    color: #1890ff;
    cursor: pointer;
  }
  // 状态 icon 图标颜色
  .pending {
    color: #83D5FF;
  }
  .running {
    color: #4977FC;
  }
  .succ {
    color: #52C41A;
  }
  .failing {
    color: #FFB75F;
  }
  .failed {
    color: #333333;
  }
  .stopping {
    color: #EC6941;
  }
  .stopped,
  .timeout {
    color: #F5222D;
  }
</style>
